import { countrySharedUtil } from '../country/country.shared.util.js';
const countryData = countrySharedUtil.getAllCountryData();
export const noDeliveryCountries = Object.entries(countryData).filter(([, data]) => !data.canDeliver).map(([code]) => code);
export const noWebshopCountries = [...noDeliveryCountries, 'BR'];
export const popularCountries = ['AU', 'BR', 'CA', 'DK', 'DE', 'FI', 'NL', 'NO', 'SE', 'GB', 'US'];
// According to https://en.wikipedia.org/wiki/Address_(geography)
export const addressFormats = {
  AU: ['name', 'address2', 'address1', 'city region zip'],
  BR: ['name', 'address1', 'address2', 'city, region', 'zip'],
  CA: ['name', 'address2', 'address1', 'city region zip'],
  DK: ['name', 'address1', 'address2', 'zip city'],
  DE: ['name', 'address2', 'address1', 'zip city'],
  FI: ['name', 'address2', 'address1', 'zip city'],
  NL: ['name', 'address2', 'address1', 'zip city'],
  NO: ['name', 'address2', 'address1', 'zip city'],
  SE: ['name', 'address2', 'address1', 'zip city'],
  GB: ['name', 'address2', 'address1', 'city', 'zip'],
  US: ['name', 'address2', 'address1', 'city, region zip'],
  // for the rest of the world, we format every address part on separate line
  RoW: ['name', 'address2', 'address1', 'city', 'region', 'zip']
};
const countryByCodeData = {};
Object.entries(countryData).forEach(([code, data]) => countryByCodeData[code] = data?.name);
export const countryByCode = countryByCodeData;
const countryByCodeNativeData = {};
Object.entries(countryData).forEach(([code, data]) => countryByCodeNativeData[code] = data?.nameNative);
export const countryByCodeNative = countryByCodeNativeData;
/**
 * We want to distinguish between the European Union and Europe due to Apples rules for external payment processors.
 * i.e. We can only offer alternate payment processors (e.g. Braintree) in European member states.
 * Source: https://developer.apple.com/support/apps-using-alternative-payment-providers-in-the-eu#commission-reports-and-payments
 */
export const EU_MEMBERS = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
export const EU_COUNTRIES = ['AX', 'FO',
// Faroe Islands
'GL',
// Greenland
// On behalf of the French, sorry:
'GF',
// French Guiana
'GP',
// Guadeloupe
'MF',
// Saint Martin
'MQ',
// Martinique
'NC',
// New Caledonia
'PF',
// French Polynesia
'PM',
// Saint Pierre and Miquelon
'RE',
// Réunion
'TF',
// French Southern Territories
'WF',
// Wallis and Futuna
'YT',
// Mayotte
...EU_MEMBERS];
/**
 * Countries where NC is allowed to sell.
 * These are EU countries, EEA countries, plus:
 * US, GB, Switzerland, Australia, ِTurkey
 * https://www.gov.uk/eu-eea
 */
export const CERTIFIED_COUNTRIES = [...EU_COUNTRIES, 'AU', 'CH', 'GB', 'IS',
// Iceland, EEA
'LI',
// Lichtenstein, EEA
'NO',
// EEA
'TR',
// Turkey
'US', 'CA',
// Certified since 2023-12
'BR' // Certified since 2025-03
];
/**
 * Countries where OURA ring is sold.
 */
export const OURA_SHIPPING_COUNTRIES = [...EU_COUNTRIES, 'AE', 'AU', 'CA', 'CH', 'FO', 'GB', 'GG', 'GL', 'JE', 'JP', 'MC', 'NO',
// EEA
'NZ', 'SA', 'SG', 'US'];
export const OURA_DISCOUNT_CURRENCY = {
  AU: 'USD',
  AT: 'EUR',
  AX: 'EUR',
  BE: 'EUR',
  BG: 'EUR',
  CA: 'USD',
  HR: 'EUR',
  CY: 'EUR',
  CZ: 'EUR',
  DK: 'EUR',
  EE: 'EUR',
  FO: 'USD',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  GR: 'EUR',
  GL: 'EUR',
  GG: 'USD',
  HU: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  JP: 'USD',
  JE: 'USD',
  LV: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  MT: 'EUR',
  MC: 'EUR',
  NL: 'EUR',
  NZ: 'USD',
  NO: 'USD',
  PL: 'EUR',
  PT: 'EUR',
  RO: 'EUR',
  SA: 'USD',
  SG: 'USD',
  SK: 'EUR',
  SI: 'EUR',
  ES: 'EUR',
  SE: 'EUR',
  CH: 'USD',
  AE: 'USD',
  GB: 'USD',
  US: 'USD'
};
/*
Currencies		          USD	SEK	  GBP	Euro	DKR	  NOK	  CAD	AUD	CHF	SGD
Prices starting from		399	5695	399	449	  3599	5490	549	649	399	599
*/
export const APPLE_WATCH_PRICES = {
  AU: '649[AUD]',
  AT: '449[EUR]',
  AX: '449[EUR]',
  BE: '449[EUR]',
  BG: '449[EUR]',
  CA: '549[CAD]',
  HR: '449[EUR]',
  CY: '449[EUR]',
  CZ: '449[EUR]',
  DK: '3599[DKK]',
  EE: '449[EUR]',
  FI: '449[EUR]',
  FR: '449[EUR]',
  DE: '449[EUR]',
  GR: '449[EUR]',
  GL: '449[EUR]',
  HU: '449[EUR]',
  IE: '449[EUR]',
  IT: '449[EUR]',
  LV: '449[EUR]',
  LT: '449[EUR]',
  LU: '449[EUR]',
  MT: '449[EUR]',
  MC: '449[EUR]',
  NL: '449[EUR]',
  NO: '5490[NOK]',
  PL: '449[EUR]',
  PT: '449[EUR]',
  RO: '449[EUR]',
  SG: '599[SGD]',
  SK: '449[EUR]',
  SI: '449[EUR]',
  ES: '449[EUR]',
  SE: '5695[SEK]',
  CH: '399[CHF]',
  GB: '399[GBP]',
  US: '399[USD]'
};
/**
 * Countries for the T2 Presale
 */
export const T2_PRESALE_COUNTRIES = [...EU_COUNTRIES, 'CH', 'GB', 'IS',
// Iceland, EEA
'LI',
// Lichtenstein, EEA
'NO',
// Norway, EEA
'IM'];